import heart_icon from "@/assets/icons/about-us/heart.svg";
import rocket_icon from "@/assets/icons/about-us/rocket-launch.svg";
import globe_icon from "@/assets/icons/about-us/globe-alt.svg";
import clipboard_icon from "@/assets/icons/about-us/clipboard.svg";
import megaphone_icon from "@/assets/icons/about-us/megaphone.svg";
import circle_stack_icon from "@/assets/icons/about-us/circle-stack.svg";

export const about = [
  {
    title: "Our difference",
    description:
      "What sets us apart is our relentless pursuit of excellence. We believe that tracking goes beyond mere location; it's about providing precision, reliability, and control in every journey.",
    iconUrl: heart_icon,
  },
  {
    title: "Innovation at the core",
    description:
      "Our commitment to innovation is woven into the fabric of Trackmate. From highly customizable solutions to seamless integrations with emerging technologies, we're at the forefront of shaping the future of intelligent tracking.",
    iconUrl: rocket_icon,
  },
  {
    title: "Beyond boundaries",
    description:
      "Headquartered in US, we take pride in our global reach and local presence. Our diverse team brings together expertise from various fields, fostering a culture of collaboration, creativity, and continuous improvement.",
    iconUrl: globe_icon,
  },
];

export const results = [
  // {
  //   title: "100,000 + active members",
  //   description:
  //     "Our community is a testament to the trust and value that users find in the Trackmate experience.",
  // },
  {
    title: "23+ years of innovation",
    description:
      "We have been involved in the vehicle tracking industry since 2001.",
  },
  {
    title: "20+ countries served",
    description: "From bustling urban landscapes to remote terrains.",
  },
];

export const types = {
  request: 'request',
  recommend: 'recommend',
  earn: 'earn'
}

export const becomeDealerData = [
  {
    title: "Create an account",
    subTitle: "Fill out the short form",
    iconUrl: clipboard_icon,
    type: types.request
  },
  {
    title: "Recommend",
    subTitle: "Promote our product",
    iconUrl: megaphone_icon,
    type: types.recommend
  },
  {
    title: "Earn",
    subTitle: "Get regular discounts",
    iconUrl: circle_stack_icon,
    type: types.earn
  },
]